// Nano ID IE support https://github.com/ai/nanoid#ie
if (!window.crypto) {
    window.crypto = window.msCrypto;
}
